import React, { FormEvent } from 'react'
import { useForm, Link, router } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import { AuthLayout } from '@/components/layouts/AuthLayout'

interface EditProfileProps {
  agent: {
    username: string
  }
  minimum_password_length: number
}

export default function EditProfile({ agent, minimum_password_length }: EditProfileProps) {
  const { data, setData, put, processing, errors } = useForm({
    agent: {
      username: agent.username,
      password: '',
      password_confirmation: '',
      current_password: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    put('/agents')
  }

  function handleDeleteAccount() {
    if (confirm('Are you sure you want to delete your account? This cannot be undone.')) {
      router.delete('/agents')
    }
  }

  return (
    <AuthLayout title="Edit profile">
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          label="Username"
          fullWidth
          autoFocus
          autoComplete="username"
          value={data.agent.username}
          onChange={e => setData('agent', { ...data.agent, username: e.target.value })}
          error={'agent.username' in errors}
          helperText={(errors as Record<string, string>)['agent.username']}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="New password"
          type="password"
          fullWidth
          autoComplete="new-password"
          value={data.agent.password}
          onChange={e => setData('agent', { ...data.agent, password: e.target.value })}
          error={'agent.password' in errors}
          helperText={(errors as Record<string, string>)['agent.password'] || 'Leave blank to keep current password'}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Confirm new password"
          type="password"
          fullWidth
          autoComplete="new-password"
          value={data.agent.password_confirmation}
          onChange={e => setData('agent', { ...data.agent, password_confirmation: e.target.value })}
          error={'agent.password_confirmation' in errors}
          helperText={(errors as Record<string, string>)['agent.password_confirmation']}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Current password"
          type="password"
          fullWidth
          autoComplete="current-password"
          value={data.agent.current_password}
          onChange={e => setData('agent', { ...data.agent, current_password: e.target.value })}
          error={'agent.current_password' in errors}
          helperText={(errors as Record<string, string>)['agent.current_password'] || 'Required to confirm changes'}
          sx={{ mb: 3 }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mb: 2 }}
        >
          Update profile
        </Button>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Link href="/" style={{ color: '#1a1a1a' }}>Back</Link>
        </Box>
      </Box>
      <Divider sx={{ my: 3 }} />
      <Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Danger zone
        </Typography>
        <Button
          variant="outlined"
          color="error"
          fullWidth
          onClick={handleDeleteAccount}
        >
          Delete my account
        </Button>
      </Box>
    </AuthLayout>
  )
}
